module.exports = __webpack_public_path__ + "static/media/UncertifiedLogin.5b53aed1.jpg";